export const US_VENUE_COSTS = {
  'Luxury Resort': { base: 20000, min: 15000, max: 25000 },
  'Private Villa': { base: 15000, min: 10000, max: 20000 },
  'Beachfront Venue': { base: 16000, min: 12000, max: 20000 },
  'Garden Estate': { base: 11500, min: 8000, max: 15000 },
  'Vineyard Estate': { base: 14000, min: 10000, max: 18000 },
  'Historic Courtyard': { base: 10500, min: 7000, max: 14000 },
  'Rooftop Terrace': { base: 12500, min: 9000, max: 16000 },
  'Boutique Hotel': { base: 11500, min: 8000, max: 15000 },
  'Mountain Lodge': { base: 14000, min: 10000, max: 18000 },
  'Chapel & Garden Combo': { base: 9000, min: 6000, max: 12000 },
  'Lakeside Retreat': { base: 13000, min: 9000, max: 17000 },
  'Colonial Mansion': { base: 16000, min: 12000, max: 20000 },
  'Cenote or Jungle Venue': { base: 0, min: 0, max: 0 },
  'Desert Villa': { base: 0, min: 0, max: 0 }
};

export const MEXICO_VENUE_COSTS = {
  'Luxury Resort': { base: 8500, min: 5000, max: 12000 },
  'Private Villa': { base: 15000, min: 10000, max: 20000 },
  'Beachfront Venue': { base: 5500, min: 3000, max: 8000 },
  'Garden Estate': { base: 6500, min: 4000, max: 9000 },
  'Vineyard Estate': { base: 7500, min: 5000, max: 10000 },
  'Historic Courtyard': { base: 9000, min: 6000, max: 12000 },
  'Rooftop Terrace': { base: 6500, min: 4000, max: 9000 },
  'Boutique Hotel': { base: 7500, min: 5000, max: 10000 },
  'Mountain Lodge': { base: 9000, min: 6000, max: 12000 },
  'Cenote or Jungle Venue': { base: 11000, min: 7000, max: 15000 },
  'Desert Villa': { base: 12000, min: 8000, max: 16000 },
  'Chapel & Garden Combo': { base: 7500, min: 5000, max: 10000 },
  'Lakeside Retreat': { base: 9000, min: 6000, max: 12000 },
  'Colonial Mansion': { base: 10500, min: 7000, max: 14000 }
};

export const VENUE_STYLES = [
  { value: 'Luxury Resort', label: 'Luxury Resort' },
  { value: 'Private Villa', label: 'Private Villa' },
  { value: 'Beachfront Venue', label: 'Beachfront Venue' },
  { value: 'Garden Estate', label: 'Garden Estate' },
  { value: 'Vineyard Estate', label: 'Vineyard Estate' },
  { value: 'Historic Courtyard', label: 'Historic Courtyard' },
  { value: 'Rooftop Terrace', label: 'Rooftop Terrace' },
  { value: 'Boutique Hotel', label: 'Boutique Hotel' },
  { value: 'Mountain Lodge', label: 'Mountain Lodge' },
  { value: 'Chapel & Garden Combo', label: 'Chapel & Garden Combo' },
  { value: 'Lakeside Retreat', label: 'Lakeside Retreat' },
  { value: 'Colonial Mansion', label: 'Colonial Mansion' }
]; 